import PropTypes from 'prop-types';
import React, { useState } from 'react';

import {
  PROVISIONAL_OFFER_COSIGNER_MODAL_OPEN,
  PROVISIONAL_OFFER_COSIGNER_OFFER_ACCEPT,
} from '../../../../constants/heapEvents';
import { track } from '../../../../lib/heapHelpers';
import ConfirmationModal from '../ConfirmationModal';
import CosignerModal from '../CosignerModal';

import './index.scss';

const ActionButtons = ({
  applicationId,
  customerGuid,
  isTermsAndConditionsAccepted,
  acceptOffer,
  rejectOffer,
  onAcceptClick,
  cosignerSelection,
  handleCosignerDetails,
  scrollToCustomiseLoanComponent,
  addAsFooter,
}) => {
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [acceptModalOpen, setAcceptModalOpen] = useState(false);
  const [cosignerModalOpen, setCosignerModalOpen] = useState(false);

  const rejectText =
    'Your application will be withdrawn. To apply again, you will need to start a new application.';
  const acceptText =
    'Thanks for continuing with the application! Please note that all other active applications will be withdrawn.';
  const cosignerDescriptionText =
    "Please provide your co-signer's name and email. " +
    "We'll reach out to them for additional details and consent. " +
    'The loan offer will be shared with them as well.';

  const handleCosignerConfirm = () => {
    setCosignerModalOpen(false);
    setAcceptModalOpen(true);
    track(PROVISIONAL_OFFER_COSIGNER_OFFER_ACCEPT, {
      'Application GUID': applicationId,
      'Customer GUID': customerGuid,
    });
  };

  const handleAcceptClick = () => {
    if (onAcceptClick) {
      onAcceptClick();
    }
    if (!isTermsAndConditionsAccepted) return;

    // Check cosigner selection and open appropriate modal
    if (cosignerSelection === 'cosigner') {
      setCosignerModalOpen(true);
      track(PROVISIONAL_OFFER_COSIGNER_MODAL_OPEN, {
        'Application GUID': applicationId,
        'Customer GUID': customerGuid,
      });
    } else {
      setAcceptModalOpen(true);
    }
  };

  return (
    <div
      className={`action-buttons-wrapper ${addAsFooter ? 'action-buttons-wrapper__footer' : ''}`}
    >
      <div className="action-buttons">
        <button className="action-buttons__accept" onClick={handleAcceptClick}>
          Accept
        </button>
      </div>
      <CosignerModal
        isOpen={cosignerModalOpen}
        onClose={() => setCosignerModalOpen(false)}
        onConfirm={handleCosignerConfirm}
        title="Add your co-signer"
        content={cosignerDescriptionText}
        confirmText="Confirm"
        cancelText="Cancel"
        handleCosignerDetails={handleCosignerDetails}
      />
      <ConfirmationModal
        isOpen={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
        onConfirm={rejectOffer}
        title="Decline offer?"
        content={rejectText}
        confirmText="Confirm"
        cancelText="Cancel"
      />
      <ConfirmationModal
        isOpen={acceptModalOpen}
        onClose={() => setAcceptModalOpen(false)}
        onConfirm={acceptOffer}
        title="Continue with offer?"
        content={acceptText}
        confirmText="Accept"
        cancelText="Cancel"
        theme={'red'}
      />
    </div>
  );
};

ActionButtons.defaultProps = {
  addAsFooter: false,
};

ActionButtons.propTypes = {
  applicationId: PropTypes.string.isRequired,
  customerGuid: PropTypes.string.isRequired,
  isTermsAndConditionsAccepted: PropTypes.bool.isRequired,
  acceptOffer: PropTypes.func.isRequired,
  rejectOffer: PropTypes.func.isRequired,
  onAcceptClick: PropTypes.func,
  cosignerSelection: PropTypes.string.isRequired,
  handleCosignerDetails: PropTypes.func.isRequired,
  scrollToCustomiseLoanComponent: PropTypes.func.isRequired,
  addAsFooter: PropTypes.bool,
};

export default ActionButtons;
